import { redirect } from 'react-router-dom';
import { getLatestRunningCampaign } from '../api/challenges';
import { toSeoUrl } from '../utils/format';

export async function loader() {
  const campaign = await getLatestRunningCampaign();

  if (!campaign) {
    return redirect('/');
  }

  return redirect(`/campaign/${toSeoUrl(campaign.name || 'campaign')}/${campaign.id}/map`);
}
